import { IConfigName } from './interface/field-type-object';

interface IDefaultDataObject {
  configName: IConfigName;
  required: boolean;
  type: string;
}

const defaultData: IDefaultDataObject = {
  configName: IConfigName.Geolocation,
  required: false,
  type: 'geolocation',
};

interface IDefaultConfigObject {
}

const defaultConfig: IDefaultConfigObject = {

};

const value = {
  title: 'Geolocation',
  icon: {
    black: require('../../icons/black/map-marker.png'),
    white: require('../../icons/white/map-marker.png'),
    blue: require('../../icons/blue/map-marker.png'),
  },
  style: {
    width: '20px',
    height: '20px'
  },
  defaultData,
  defaultConfig
}

export default value;